import { cookiesAccess } from '@codestreet/analytics'

export default defineNuxtPlugin(() => cookiesAccess.initShow())
